@if (display) {
  <div class="td-wb-toolbar-container"
       [ngClass]="{ 'td-wb-toolbar-container--sticky': menuSticky, 'td-wb-toolbar-container--modal': modal }">
    <div class="td-wb-toolbar"
         role="toolbar"
         [ngClass]="{ 'td-wb-toolbar--sticky': menuSticky }">
      <ng-content />
    </div>
  </div>
}
